/* AM — Galeria e kartes + "Shto ne shporte" i shpejte (2026-10-07). Shiko snippets/am-card-gallery.liquid.
   Te gjitha ngjarjet jane te deleguara ne document, ndaj punon edhe kur filtrat e Dawn rindertojne grid-in. */
(function () {
  if (window.__amGal) return;
  window.__amGal = true;

  var sq = (document.documentElement.lang || '').toLowerCase().indexOf('sq') === 0;
  var T = sq
    ? { add: 'Shto në shportë', sel: 'Zgjidh masën', err: 'Nuk u shtua. Provo sërish.' }
    : { add: 'Add to cart', sel: 'Select size', err: 'Could not add. Please try again.' };

  /* ---------- Galeria ---------- */
  function loadRest(track) {
    if (!track || track.getAttribute('data-am-loaded')) return;
    track.setAttribute('data-am-loaded', '1');
    track.querySelectorAll('img[data-am-srcset]').forEach(function (img) {
      img.setAttribute('srcset', img.getAttribute('data-am-srcset'));
      img.setAttribute('src', img.getAttribute('data-am-src'));
      img.removeAttribute('data-am-srcset');
      img.removeAttribute('data-am-src');
    });
  }

  function paint(track) {
    var gal = track.parentNode;
    var bar = gal && gal.querySelector('.am-gal__bar i');
    var n = track.children.length;
    if (bar && n > 1) {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? Math.min(Math.max(track.scrollLeft / max, 0), 1) : 0;
      bar.style.transform = 'translateX(' + (p * (n - 1) * 100) + '%)';
    }
    if (track.scrollLeft > 2) loadRest(track);
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('am-gal__track')) paint(t);
  }, true);

  document.addEventListener('touchstart', function (e) {
    var g = e.target && e.target.closest ? e.target.closest('.am-gal') : null;
    if (g) loadRest(g.querySelector('.am-gal__track'));
  }, { passive: true });

  document.addEventListener('mouseover', function (e) {
    var g = e.target && e.target.closest ? e.target.closest('.am-gal') : null;
    if (g) loadRest(g.querySelector('.am-gal__track'));
  }, { passive: true });

  /* ---------- Butoni poshte ekranit ---------- */
  var qa = null, qaOpts = null, qaBtn = null, state = null, io = null;

  function ensure() {
    if (qa) return;
    qa = document.createElement('div');
    qa.className = 'am-qa';
    qa.setAttribute('role', 'region');
    qa.innerHTML = '<div class="am-qa__opts" hidden></div><button type="button" class="am-qa__btn"></button>';
    document.body.appendChild(qa);
    qaOpts = qa.querySelector('.am-qa__opts');
    qaBtn = qa.querySelector('.am-qa__btn');
    qaBtn.addEventListener('click', add);
    qaOpts.addEventListener('click', function (e) {
      var p = e.target.closest('.am-qa__pill');
      if (!p || p.disabled || !state) return;
      qaOpts.querySelectorAll('.is-sel').forEach(function (x) { x.classList.remove('is-sel'); });
      p.classList.add('is-sel');
      state.vid = p.getAttribute('data-id');
      qaBtn.disabled = false;
      qaBtn.textContent = T.add;
    });
  }

  function close() {
    if (!qa || !state) return;
    qa.classList.remove('is-open');
    state.plus.classList.remove('is-active');
    state.plus.setAttribute('aria-expanded', 'false');
    state = null;
    if (io) { io.disconnect(); io = null; }
  }

  function open(plus) {
    ensure();
    if (state && state.plus === plus) { close(); return; }
    if (state) { state.plus.classList.remove('is-active'); state.plus.setAttribute('aria-expanded', 'false'); }
    state = { plus: plus, vid: plus.getAttribute('data-vid') };
    plus.classList.add('is-active');
    plus.setAttribute('aria-expanded', 'true');
    qaBtn.classList.remove('is-busy');
    qaOpts.innerHTML = '';
    var raw = plus.getAttribute('data-v');
    if (raw) {
      var list = [];
      try { list = JSON.parse(raw); } catch (err) { list = []; }
      list.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'am-qa__pill';
        b.setAttribute('data-id', v.id);
        b.textContent = String(v.t).replace(/^(ring\s*)?size\s*/i, '');
        if (!v.a) b.disabled = true;
        qaOpts.appendChild(b);
      });
      qaOpts.hidden = false;
      qaBtn.disabled = true;
      qaBtn.textContent = T.sel;
    } else {
      qaOpts.hidden = true;
      qaBtn.disabled = false;
      qaBtn.textContent = T.add;
    }
    requestAnimationFrame(function () { qa.classList.add('is-open'); });
    if ('IntersectionObserver' in window) {
      if (io) io.disconnect();
      var card = plus.closest('.card-wrapper') || plus;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting) close(); });
      });
      io.observe(card);
    }
  }

  function add() {
    if (!state || !state.vid || qaBtn.classList.contains('is-busy')) return;
    var vid = state.vid;
    qaBtn.classList.add('is-busy');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (qaBtn) qaBtn.classList.remove('is-busy');
        if (res.status) { fail(res.description || res.message); return; }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'am-quick-add', productVariantId: vid, cartData: res });
        }
        close();
        cart.renderContents(res);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function () { if (qaBtn) qaBtn.classList.remove('is-busy'); fail(); });
  }

  function fail(msg) {
    if (!qaBtn) return;
    qaBtn.textContent = msg || T.err;
    setTimeout(function () { if (state && qaBtn) qaBtn.textContent = state.vid ? T.add : T.sel; }, 2600);
  }

  /* ---------- Klikimet ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var nav = t.closest('.am-gal__nav');
    if (nav) {
      e.preventDefault();
      e.stopPropagation();
      var track = nav.parentNode.querySelector('.am-gal__track');
      if (!track) return;
      loadRest(track);
      var dir = nav.classList.contains('am-gal__nav--next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      return;
    }

    var plus = t.closest('.am-gal__plus');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      open(plus);
      return;
    }

    if (state && qa && !qa.contains(t)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
